<div
  class="badge-action"
  [class]="'theme-' + theme"
  [class.disabled]="disabled"
  (click)="handleTap()"
>
  {{value}}
</div>
